import React from "react";
import { useSelector } from "react-redux";

import styles from "./save-blueprint-modal.module.scss";

import { RootState } from "@src/reducers/store";
import { SaveBlueprintModalContent } from "./save-content/save-content";
import { ReplaceBlueprintModalContent } from "./replace-content/replace-content";
import { GlassyModal } from "../../glassy-modal/glassy-modal";

const cssClassName = "save-blueprint-modal";

export const SaveBluePrintModal = () => {
  const blueprintModalContentShown = useSelector(
    (state: RootState) =>
      state.yourSlice.saveBlueprintModal.blueprintModalContentShown,
  );

  const renderSaveOrReplaceBlueprintModalContent = (value) => {
    switch (value) {
      case "save":
        return <SaveBlueprintModalContent />;
      case "replace":
        return <ReplaceBlueprintModalContent />;
      default:
        return <SaveBlueprintModalContent />;
    }
  };

  return (
    <GlassyModal>
      <div className={styles[cssClassName]}>
        {renderSaveOrReplaceBlueprintModalContent(blueprintModalContentShown)}
      </div>
    </GlassyModal>
  );
};
